import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import MajorCategoryServices from './major_category_services';

export const CreateMajorCategory = createAsyncThunk(
  'major_category/create_major_category',
  async (requestData, thunkAPI) => {
    try {
      const delivered = await MajorCategoryServices.MajorCreateCategory(
        requestData
      );

      return delivered;
    } catch (e) {
      toast(e.message);
      return thunkAPI.rejectWithValue(e);
    }
  }
);

export const UploadMajorCategoryImage = createAsyncThunk(
  'major_category/major_category_image',
  async (requestData, thunkAPI) => {
    try {
      const delivered = await MajorCategoryServices.uploadMajorCategoryImage(
        requestData
      );

      return delivered;
    } catch (e) {
      toast(e.message);
      console.log('Error', e);
      return thunkAPI.rejectWithValue(e);
    }
  }
);

export const UploadMajorCategoryIcon = createAsyncThunk(
  'major_category/major_category_icon',
  async (requestData, thunkAPI) => {
    try {
      const delivered = await MajorCategoryServices.uploadMajorCategoryIcon(
        requestData
      );

      return delivered;
    } catch (e) {
      toast(e.message);
      console.log('Error', e);
      return thunkAPI.rejectWithValue(e);
    }
  }
);

export const GetAllMajorCategory = createAsyncThunk(
  'major_category/get_all_major_category',
  async (payload, thunkAPI) => {
    try {
      let response = await MajorCategoryServices.getAllMajorCategory(payload);

      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const GetAllMajorMajorCategory = createAsyncThunk(
  'major_category/get_all_major_major_category',
  async (payload, thunkAPI) => {
    try {
      let response = await MajorCategoryServices.getAllMajorMajorCategory();

      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const DeleteMajorCategory = createAsyncThunk(
  'major_category/delete_major_Category',
  async (payload, thunkAPI) => {
    try {
      let response = await MajorCategoryServices.DeleteMajorCategory(payload);

      return response;
    } catch (error) {
      toast(error.message);
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const GetSingleMajorCategoryDetails = createAsyncThunk(
  'major_category/get_single_major_category',
  async (payload, thunkAPI) => {
    try {
      let response = await MajorCategoryServices.getSingleMajorCategoryDetails(
        payload
      );

      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const SearchForMajorCategorysByName = createAsyncThunk(
  'major_category/searchForMajorCategorysByName',
  async (payload, thunkAPI) => {
    try {
      const delivered =
        await MajorCategoryServices.SearchForMajorCategoryByName(payload);

      return delivered;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);
